import { useReveal } from "@/hooks/useReveal";
import { ui } from "@/data/translations";

export default function ManifestoSection({ content, language }) {
  const text = ui[language];
  const [ref, visible] = useReveal(0.12);
  const image = content.images.find((item) => item.role === "manifesto") || content.images[0];
  return (
    <section className="manifesto-section section-pad" id="approach" ref={ref} aria-labelledby="approach-title">
      <div className={`page-width manifesto-layout reveal ${visible ? "is-visible" : ""}`}>
        <div className="manifesto-image-wrap"><img src={image?.url || content.hero_image_url} alt={language === "en" ? image?.alt_en : image?.alt_es} /><div className="manifesto-image-label">VGC / HAND + MATERIAL</div></div>
        <div className="manifesto-copy"><p className="eyebrow eyebrow-light">{text.approachEyebrow}</p><h2 id="approach-title">{text.approachTitle}</h2><div className="chapter-list">
          {content.manifesto.map((chapter) => <article className="chapter" key={chapter.id} data-testid={`manifesto-chapter-${chapter.number}`}><span className="chapter-number">{chapter.number}</span><div><h3>{language === "en" ? chapter.title_en : chapter.title_es}</h3><p>{language === "en" ? chapter.summary_en : chapter.summary_es}</p></div><span className="chapter-metric">{chapter.metric}</span></article>)}
        </div></div>
      </div>
    </section>
  );
}
